import { STATUSES } from "Utils/constants";
import { setStatus, setPopup, setRedirect } from "../Store/ErrorInfoSlice";
import { store } from 'Store';
import { clearFields } from "Store/LoginInfoSlice";


// Example 1
/*
    status: STATUSES.NORMAL,
    popup: {
      visible: false,
      title: "",
      msg: "",
      showContactHelp: false
    },
    redirect: {
      redirect: false, 
      path: "",
      data:{}
    }
*/

// Example 2
/*
    status: {
        code: -1,
        text: "error"
    },
    popup: {
      visible: true,
      title: "Data Error",
      msg: "There was an error",
      showContactHelp: true
    },
    redirect: {
      redirect: true, 
      path: "",
      data:{}
    }
*/

const state = store.getState().errorInfo;

function getRedirectData (redirectData) {
    var redirect = false;
    var path = "";
    var data = {};
    var redirectFirst = false;

    if (redirectData != null) {
        if ("redirect" in redirectData && redirectData.redirect != null) {
            redirect = redirectData.redirect;
        }
        if ("path" in redirectData && redirectData.path != null) {
            path = redirectData.path;
        }
        if ("data" in redirectData && redirectData.data != null) {
            data = redirectData.data;
        }
        if ("redirectFirst" in redirectData && redirectData.redirectFirst != null) {
            redirect = redirectData.redirectFirst;
        }
    }
    return {
        redirect: redirect,
        redirectFirst: redirectFirst,
        path: path,
        data: data
    }
}

function getPopupData (popupData) {
    var visible = false;
    var title = "";
    var msg = "";
    var showContactHelp = false;

    if (popupData != null) {
        if ("visible" in popupData && popupData.visible != null) {
            visible = popupData.visible;
        }
        if ("title" in popupData && popupData.title != null) {
            title = popupData.title;
        }
        if ("msg" in popupData && popupData.msg != null) {
            msg = popupData.msg;
        }
        if ("showContactHelp" in popupData && popupData.showContactHelp != null) {
            showContactHelp = popupData.showContactHelp;
        }
    }
    return {
        visible: visible,
        title: title,
        msg: msg,
        showContactHelp: showContactHelp
    }
}

export const setGlobalErrorStatus = ({ dispatch, popupData, redirect, error }) => {
    var statusCode = 0;
    if (error != null) {
        if (error.hasOwnProperty("response") && error.response.hasOwnProperty("status")) {
            statusCode = error.response.status;
        }
        else if (error.hasOwnProperty("data") && error.data.hasOwnProperty("response") && error.data.response.hasOwnProperty("status")) {
            statusCode = error.data.response.status;
        }
    }
    //console.log("Error caught: " + popupData.msg);
    //console.log(JSON.stringify(error));
    //console.log(statusCode);
    //console.log(error.response);
    //console.log(error.data);

    if (statusCode == 401) {
        //console.log("dispatch");
        dispatch(setStatus(STATUSES.SESSION_TIMEOUT));
        dispatch(setPopup({
            //title: "Session Expired",
            //msg: "Your session has expired, please login again.",
            visible: true,
            title: "Sign in Required",
            msg: "You've been signed out, please sign in again.",
            showContactHelp: false
        }));
        dispatch(clearFields());
    }
    else if (state.status != STATUSES.ERROR) {
        dispatch(setStatus(STATUSES.ERROR));
        dispatch(setPopup(getPopupData(popupData)));
        dispatch(setRedirect(getRedirectData(redirect)));
    }
}

export const setGlobalSuccessStatus = ({ dispatch, popupData, redirect }) => {
    //console.log("Success: " + popupData.msg);
    //if(state.status!=STATUSES.SUCCESS){
    dispatch(setStatus(STATUSES.SUCCESS));
    dispatch(setPopup(getPopupData(popupData)));
    dispatch(setRedirect(getRedirectData(redirect)));
    //}
}

export const setGlobalWarningStatus = ({ dispatch, popupData, redirect }) => {
    //console.log("Warning: " + popupData.msg);
    dispatch(setStatus(STATUSES.WARNING));
    dispatch(setPopup(getPopupData(popupData)));
    dispatch(setRedirect(getRedirectData(redirect)));
}

export const setBatchErrorStatus = ({ dispatch, popupData, redirect }) => {
    //console.log("Batch Error" + popupData.msg);
    dispatch(setStatus(STATUSES.BATCH_ERROR));
    dispatch(setPopup(getPopupData(popupData)));
    dispatch(setRedirect(getRedirectData(redirect)));
}
